import React from 'react';

function Quote(props){
    return(
        <h3 id="text"><i class="fas fa-quote-left"></i> {props.text}</h3>
    )
}

export default Quote;
